import { render, staticRenderFns } from "./BasicPaymentPage.vue?vue&type=template&id=db1c9592&scoped=true"
import script from "./BasicPaymentPage.vue?vue&type=script&lang=js"
export * from "./BasicPaymentPage.vue?vue&type=script&lang=js"
import style0 from "./BasicPaymentPage.vue?vue&type=style&index=0&id=db1c9592&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1c9592",
  null
  
)

export default component.exports